<script>
import baseMixin from '@/mixins/baseMixin'
import truncatedListMixin from '@/mixins/truncatedListMixin'

export default {
  name: 'TruncatedList',
  mixins: [baseMixin, truncatedListMixin],
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    chips: {
      type: Boolean,
      default: false,
    },
    label: {
      type: Boolean,
    },
    chipClass: {
      type: String,
      default: '',
    },
    limit: {
      type: Number,
      default: 0,
    },
    textClass: {
      type: String,
      default: 'caption',
    },
    inline: {
      type: Boolean,
    },
  },
  created() {
    if (this.limit <= 0) this.limit = 0 // If zero is passed in, no items are truncated
  },
}
</script>

<template>
  <div :class="[inline ? 'd-inline' : '', 'truncated-list']">
    <span
      v-for="(item, index) in itemsToShow"
      :key="index"
      class="truncated-list_visible-list"
    >
      <span v-if="chips">
        <v-chip
          v-if="hasOneOrMoreItems"
          :class="['mr-1 mb-1', chipClass]"
          :label="label"
          v-bind="$attrs"
          v-on="$listeners"
        >
          {{ item }}
        </v-chip>
      </span>
      <span v-else :class="textClass">{{
        `${notFirstIndex(index) ? ', ' : ''} ${item}`
      }}</span>
    </span>

    <v-tooltip v-if="hasMoreItemsThanLimit" top>
      <template v-slot:activator="{ on }">
        <div
          :class="[
            'cursor-pointer blue--text d-inline-block ml-2 truncated-list_truncate-text',
            textClass,
          ]"
          v-bind="$attrs"
          v-on="on"
        >
          {{ hiddenItemsText }}
        </div>
      </template>
      <div style="max-width: 250px !important;">
        <span v-for="(item, index) in hiddenItems" :key="index">
          <span>{{ `${notFirstIndex(index) ? ', ' : ''}${item}` }}</span>
        </span>
      </div>
    </v-tooltip>
  </div>
</template>
